// A Productivity Tracker discipline whose roll-up mode is 'Qty' carries its
// quantity in the same box the 'Row' mode uses for the row number, typed as
// "11" or "11 EA". No phase of such a discipline holds the count of units
// (each QPAC phase carries a per-node rollup), so Max / Sum / Row can't show it.
export function parseQtyMath(text) {
    const m = String(text == null ? '' : text).trim().match(/^(-?[\d,]*\.?\d+)\s*([A-Za-z%/]*)$/);
    if (!m) return { qty: 0, uom: '' };
    return { qty: Number(m[1].replace(/,/g, '')) || 0, uom: m[2] ? m[2].toUpperCase() : '' };
}

// The unit of a 'Sum' roll-up: the one unit its phases name, ignoring case and
// phases that name none; '' when they name different units, since the sum then
// has no single unit. UG Electrical's conduit sizes are all LF (Seth 10/19).
export function sharedUnit(units) {
    const seen = new Map();
    (units || []).forEach((u) => {
        const s = String(u == null ? '' : u).trim();
        if (s && !seen.has(s.toUpperCase())) seen.set(s.toUpperCase(), s);
    });
    return seen.size === 1 ? [...seen.values()][0] : '';
}
